import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { SALE_ROUTE_PATH } from '../components/shared/constants';

const SaleRoute = (
  <Route
    key={SALE_ROUTE_PATH}
    path={SALE_ROUTE_PATH}
    handle={{
      clientSide: true,
    }}
    lazy={async () => ({
      Component: (await import(
        /* webpackChunkName: 'marketplace' */
        '../components/discovery/sales/sale_grid'
      )).default,
    })}
  />
);

export default SaleRoute;
